import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import PostCodeInfo from '@/model/modules/PostCodeInfo'

export default class UserGroupService extends BaseService {
  protected static baseUrl: string = '/postcode'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<PostCodeInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<PostCodeInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/postcode-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<PostCodeInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
